import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface GratitudeMessageProps {
  name: string;
  message: string;
  date: string;
  relationship: string;
}

const GratitudeMessage = ({ name, message, date, relationship }: GratitudeMessageProps) => {
  return (
    <div className="bg-surface rounded-lg p-5 border border-border hover:border-primary/30 transition-all duration-300">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="HeartIcon" size={18} className="text-primary" variant="solid" />
          </div>
          <div>
            <h4 className="font-inter text-sm font-semibold text-foreground">{name}</h4>
            <p className="font-inter text-xs text-muted-foreground">{relationship}</p>
          </div>
        </div>
        <span className="font-inter text-xs text-muted">{date}</span>
      </div>
      <p className="font-inter text-sm text-foreground leading-relaxed">{message}</p>
    </div>
  );
};

export default GratitudeMessage;